import { useEffect } from 'react';
import { Route, Routes } from 'react-router';
import { CommodityManagementApi } from '../../../Apis/Apis';
import { CommodityManagementSiteAccessModel } from '../../../Generated/Commodity-Management-Api';
import { useLoadingState } from '../../../Hooks';
import { RootState, useApplicationDispatch, useApplicationSelector } from '../../../Redux/ReduxStore';
import { resetCommodityManagementState, setCommodityManagementState } from '../../../Redux/Slices/CommodityManagementSlice';
import { StoneXLoading } from '../../StoneX';
import UpdateBudgetsPage from './Budgets/UpdateBudgetsPage/UpdateBudgetsPage';
import ViewBudgetsPage from './Budgets/ViewBudgetsPage/ViewBudgetsPage';
import ViewPositionsPage from './Positions/ViewPositionsPage/ViewPositionsPage';
import ReportsPage from './Reports/ReportsPage';
import SettingsPage from './Settings/SettingsPage';
import NotesPage from './Notes/NotesPage';
import UpdatePositionsPage from './Positions/UpdatePositionsPage/UpdatePositionsPage';
import AddBudgetsPage from './Budgets/AddBudgetsPage/AddBudgetsPage';
import ViewAllocationsPage from './Allocations/ViewAllocationsPage';
import Dashboard from './Dashboard/Dashboard';
import ChatResultsPage from './Dashboard/ChatResultsPage';
import AssistantPage from './Dashboard/AssistantPage';
import { LoadingState } from '../../../Types';

interface CommodityManagementSolutionProps {
}

export default function CommodityManagementSolution(props: CommodityManagementSolutionProps) {

    const activeSite = useApplicationSelector((state: RootState): CommodityManagementSiteAccessModel => state.activeSite.site);
    const loadingState = useApplicationSelector((state: RootState): LoadingState => state.commodityManagement.siteLoadingState);

    if (activeSite) {
        if (loadingState === LoadingState.Loading || loadingState === LoadingState.None) {
          return <StoneXLoading show/>
        }

        return (
            // Setting the site's guid as the key will force the component to reload when the site changes
            <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }} key={activeSite.siteGuid}>
                <Routes>
                    <Route path="settings" element={<SettingsPage />} />
                    <Route path="budgets" element={<ViewBudgetsPage />} />
                    <Route path="budgets/add" element={<AddBudgetsPage />} />
                    <Route path="positions" element={<ViewPositionsPage />} />
                    <Route path="positions/add" element={<UpdatePositionsPage />} />
                    <Route path="allocations" element={<ViewAllocationsPage />} />
                    <Route path="reports" element={<ReportsPage />} />
                    <Route path="notes" element={<NotesPage />} />
                    <Route path="dashboard/:locationId" element={<Dashboard />} />
                    <Route path="chat-results" element={<ChatResultsPage />} />
                    <Route path="assistant" element={<AssistantPage />} />
                </Routes>
            </div>
        );
    }
    else {
        return <h3>Please select a site to begin</h3>;
    }
}
